import { create } from 'zustand';

const useChannelStore = create((set, get) => ({
  // State
  channels: [],
  activeChannelId: null,
  categories: [],

  // Actions
  setChannels: (channels) => set({ channels }),

  addChannel: (channel) =>
    set((state) => ({
      channels: [...state.channels, channel],
    })),

  updateChannel: (id, updates) =>
    set((state) => ({
      channels: state.channels.map((ch) =>
        ch.id === id ? { ...ch, ...updates } : ch,
      ),
    })),

  removeChannel: (id) =>
    set((state) => ({
      channels: state.channels.filter((ch) => ch.id !== id),
      activeChannelId:
        state.activeChannelId === id ? null : state.activeChannelId,
    })),

  setActiveChannel: (id) => set({ activeChannelId: id }),

  setCategories: (categories) => set({ categories }),

  incrementUnread: (channelId) =>
    set((state) => ({
      channels: state.channels.map((ch) =>
        ch.id === channelId
          ? { ...ch, unreadCount: (ch.unreadCount || 0) + 1 }
          : ch,
      ),
    })),

  resetUnread: (channelId) =>
    set((state) => ({
      channels: state.channels.map((ch) =>
        ch.id === channelId ? { ...ch, unreadCount: 0 } : ch,
      ),
    })),

  getChannelById: (id) => get().channels.find((ch) => ch.id === id) || null,
}));

export default useChannelStore;
